import { render } from "./offers.vue?vue&type=template&id=f7fe44b6"
import script from "./offers.vue?vue&type=script&lang=js"
export * from "./offers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__